import { render } from "./BoxesCountDashboard.vue?vue&type=template&id=6361ec1b"
import script from "./BoxesCountDashboard.vue?vue&type=script&lang=js"
export * from "./BoxesCountDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__